import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { knowledgeService } from '../../../services/KnowledgeService';
import { knowledgeQueryKeys } from '../knowledgeQueryKeys';

type UseKnowledgeCrawlUrlNodesQueryOptions = {
  databaseId: string | undefined;
  crawlId: string | undefined;
  enabled: boolean;
};

export function useKnowledgeCrawlUrlNodesQuery({
  databaseId,
  crawlId,
  enabled,
}: UseKnowledgeCrawlUrlNodesQueryOptions) {
  const { user } = useAuth();
  const isEnabled =
    enabled && Boolean(user) && Boolean(databaseId) && Boolean(crawlId);

  return useQuery({
    queryKey: knowledgeQueryKeys.crawlUrlNodes(databaseId ?? '', crawlId ?? ''),
    enabled: isEnabled,
    queryFn: () => knowledgeService.listCrawlUrlNodes(databaseId!, crawlId!),
  });
}
